import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { LanguageProvider } from "./i18n/LanguageContext";
import { ScrollToTop } from "./components/ScrollToTop";
import MobileFixedCTA from "./components/feature/MobileFixedCTA";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <LanguageProvider>
          <AppRoutes />
          <MobileFixedCTA />
        </LanguageProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
